import { Checkbox } from "emoreg";
import { Typography } from "emoreg/atoms/Typography";

import { ZoneContainer } from "./mutualized-area-checkbox.styles";

interface MutualizedAreaCheckboxProps {
  mutualizedAreaUuid: string;
  checked: boolean;
  label: string;
  onToggle: (mutualizedAreaUuid: string) => void;
}

export const MutualizedAreaCheckbox = ({
  mutualizedAreaUuid,
  checked,
  label,
  onToggle,
}: MutualizedAreaCheckboxProps) => (
  <ZoneContainer justifyContent="space-between" alignItems="center">
    <Checkbox
      id={mutualizedAreaUuid}
      checked={checked}
      label={<Typography fontWeight={600}>{label}</Typography>}
      onChange={() => onToggle(mutualizedAreaUuid)}
    />
  </ZoneContainer>
);
